<li *ngIf="!finishedAndLocked && !hasMissingValue" nz-menu-item (click)="toggleMissingValue()">
	<span class="text-uppercase font-size-12 mr-2">
		<i-feather name="plus" class="icon"></i-feather>
	</span>
	{{ 'word.missing_value_use_with_title' | translate: {missing_value: meta?.title} }}
</li>
<li *ngIf="!finishedAndLocked && hasMissingValue" nz-menu-item (click)="toggleMissingValue()">
	<span class="text-uppercase font-size-12 mr-2">
		<i-feather name="x" class="icon"></i-feather>
	</span>
	{{ 'word.missing_value_remove_with_title' | translate: {missing_value: meta?.title} }}
</li>
<li *ngIf="finishedAndLocked && hasMissingValue" class="px-3">
	<span class="text-uppercase font-size-12 mr-2">
		<i-feather name="check" class="icon"></i-feather>
	</span>
	{{ meta?.title }}
</li>

<workflow-missing-value-modal (clickOk)="enableMissingValue()" [(showMissingValueModal)]="showMissingValueModal"></workflow-missing-value-modal>
